var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .969a6.78 6.78 0 1 0 0 13.562A6.78 6.78 0 1 0 7 .969zm3.309 8.586c.137.109.137.328 0 .465l-1.066 1.066c-.137.137-.355.137-.465 0L7 9.281l-1.805 1.805c-.109.137-.328.137-.465 0L3.664 9.992c-.137-.109-.137-.328 0-.465L5.469 7.75 3.664 5.973c-.137-.109-.137-.328 0-.465l1.094-1.066c.109-.137.328-.137.465 0L7 6.219l1.777-1.777c.109-.137.328-.137.465 0l1.066 1.066c.137.137.137.355 0 .465L8.531 7.75l1.777 1.805z",
    fill: "#ff2b2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.8009a06c45978a8bd211ce47d446567a.svg";
export { ForwardRef as ReactComponent };